export const paymentChargeInfo = {
  au: {
    label: "VISA/Mastercard - Surcharge 0.88% + GST",
    details: [],
  },
  nz: {
    label: "Credit Card Payment Merchant Service Fee (MSF)",
    details: ["Domestic Cards:         2.65% + NZ$0.30", "International Cards:    3.7% + NZ$0.30"],
  },
  ca: null, // No charge for Canada
};
